import http from "../http-common";

const SAUDI = process.env.REACT_APP_MARKET === "SAUDI";
const SPAIN = process.env.REACT_APP_MARKET === "SPAIN";

class TempFileUploadService {

  create(data, multiple = false) {
    let formData = new FormData();
    console.info("---------",process.env.REACT_APP_MARKET);
    
    if(SAUDI){
      formData.append("projectId", data.projectId);
      formData.append("supplierCode", data.supplierCode);
      formData.append("filetype", data.filetype);
      formData.append("year", data.year);
      formData.append("month", data.month);
      formData.append("file", data.file);
  
      if(multiple) {
        for (let i = 0; i < data.file.length; i++) {
          formData.append('file', data.file[i]);
        }
      } else {
          formData.append("file", data.file);
      }
      console.info("---------",formData);
      if(multiple){
        return http.post("/tempfileupload/multiple", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
      } else {
        return http.post("/tempfileupload", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
      }
    } else if(SPAIN){
      formData.append("projectId", data.projectId);
      formData.append("supplierCode", data.supplierCode);
      formData.append("year", data.year);
      formData.append("month", data.month);

      if(multiple) {
        for (let i = 0; i < data.file.length; i++) {
          formData.append('file', data.file[i]);
        }
      } else {
          formData.append("file", data.file);
      }

      console.info("---------",formData);
      if(multiple){
        return http.post("/tempfileupload/multiple", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
      } else {
        return http.post("/tempfileupload", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
      }
    }

    
  }

}

export default new TempFileUploadService();